import refs from '../helpers/refs'
import './c-instruction-manual-category.js'
import './c-instruction-manual-search.js'

class CInstructionManuals {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-instruction-manuals')
    .forEach(el => new CInstructionManuals(el))
})
